import { InstaPayLogo } from "@/Svg/Svg";
import { Search } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import HeaderRight from "../Common/HeaderRight";

const Navbar = ({
  fromStore = false,
  storeId = undefined,
  storeLogo = undefined,
  storeTitle = "",
  storeHashId = "",
}) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const { t } = useTranslation();
  const [mobileHeaderView, setMobileHeaderView] = useState();
  return (
    <>
      <div
        className={` w-full flex justify-between items-center py-2 bg-[#FFFFFF] px-4  lg:border broder-0  `}
      >
        <div className="hidden lg:block relative w-auto">
          <form
            className="  relative flex items-center w-[280px] h-[40px] px-4 gap-2 border border-[#E4E3E5] rounded-[100px] bg-white"
            onSubmit={(e) => {
              e.preventDefault();
              navigate(
                `/search?searchTerm=${query}${
                  storeId ? `&storeId=${storeId}` : ""
                }`,
              );
            }}
          >
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={t(
                storeId ? "Search from this store" : "Search anything...",
              )}
              className="w-full h-full bg-transparent placeholder:font-[600] placeholder:text-[#6D6C79] focus:outline-none"
            />
            <button type="submit">
              <Search size={18} className="text-black cursor-pointer" />
            </button>
          </form>
        </div>
        <div
          onClick={() => navigate(storeHashId ? `/store/${storeHashId}` : "/")}
          className="w-auto flex cursor-pointer items-center justify-center"
        >
          <InstaPayLogo width="25"  height="30" />
          <span className="font-bold lg:text-[28px] text-[20px] text-[#000] block ">InstaPay</span>
        </div>

        <HeaderRight
          setMobileHeaderView={setMobileHeaderView}
          mobileHeaderView={mobileHeaderView}
          query={query}
          setQuery={setQuery}
          navigate={navigate}
          storeId={storeId}
        />
      </div>
      <div className=" block lg:hidden relative w-auto px-5">
        <form
          className="  relative flex items-center w-[100%] h-[40px] px-4 gap-2 border border-[#E4E3E5] rounded-[100px] bg-white"
          onSubmit={(e) => {
            e.preventDefault();
            navigate(
              `/search?searchTerm=${query}${
                storeId ? `&storeId=${storeId}` : ""
              }`,
            );
          }}
        >
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t(
              storeId ? "Search from this store" : "Search anything...",
            )}
            className="w-full h-full bg-transparent placeholder:font-bold placeholder:text-[#6D6C79] focus:outline-none"
          />
          <button type="submit">
            <Search size={18} className="text-black cursor-pointer" />
          </button>
        </form>
      </div>
      {/* {!location.pathname.startsWith("/dashboard") && (
        <div className="w-full bg-white flex justify-center items-center mb-6">
          <div
            className="w-[40vw]  flex justify-center items-center
         gap-8 py-3 border border-t-0 rounded-b-[12px]
 border-[#E4E3E5]"
          >
            <select className="text-xs font-semibold text-[#6D6C79] uppercase cursor-pointer hover:text-black">
              <option> Categories</option>
              <option>Electronics</option>
              <option>Fashion</option>
              <option>Home & Garden</option>
              <option>Sports</option>
              <option>Toys</option>
            </select>

            <select className="text-xs font-semibold text-[#6D6C79] uppercase cursor-pointer hover:text-black">
              <option> Brands</option>
              <option>Apple</option>
              <option>Samsung</option>
              <option>LG</option>
              <option>Microsoft</option>
            </select>

            <span className="text-xs font-semibold text-[#6D6C79] uppercase cursor-pointer hover:text-black">
              Flash Sale
            </span>

            <span className="text-xs font-semibold text-[#6D6C79] uppercase cursor-pointer hover:text-black">
              Top Deals
            </span>

            <span className="text-xs font-semibold text-[#6D6C79] uppercase cursor-pointer hover:text-black">
              Contact Us
            </span>
          </div>
        </div>
      )} */}
    </>
  );
};

export default Navbar;
